import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { SidebarBottomItem } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/SidebarBottomItem.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { useGetSettingsPrefix } from '#pplx/frontend/apps/ask/settings/hooks/useGetSettingsRoute.js';
import Avatar from '#pplx/frontend/components/user/Avatar.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useIntl } from 'react-intl';
export const SidebarEnterpriseMenu = ({ isExpanded, trailingAccessory, }) => {
    const reason = 'sidebar-v2-enterprise-menu';
    const { $t } = useIntl();
    const { organization } = useUserOrgData({ reason });
    const settingsPrefix = useGetSettingsPrefix();
    const tooltipContent = organization?.display_name ??
        $t({
            defaultMessage: 'Organization',
            description: 'Fallback tooltip for the organization button when no organization name is set',
            id: 'd3cb02af55',
        });
    return (_jsxs(SidebarBottomItem.Root, { isExpanded: isExpanded, hasTrailing: !!trailingAccessory, children: [_jsx(SidebarBottomItem.Leading, { href: `${settingsPrefix}/org`, tooltip: tooltipContent, children: _jsx("div", { children: organization?.logo ? (_jsx(Avatar, { size: "base", user: organization?.logo, altText: "Logo" })) : (_jsx(Icon, { icon: $icon('building'), size: "medium" })) }) }), trailingAccessory && (_jsx(SidebarBottomItem.Trailing, { children: trailingAccessory }))] }));
};
//# sourceMappingURL=SidebarEnterpriseMenu.js.map